export class EmailContentPlainTextResultDto {
    contentPlainText: string;
}
